import {Component, OnInit} from '@angular/core';
import {hasPermissionTo} from "../core/visbos-core/authorization/guards/has-permission-to.guard";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../shared/redux-store/store";

@Component({
  selector: 'vb-admin-module',
  templateUrl: './admin-module.component.html',
  styleUrls: ['./admin-module.component.css']
})
export class AdminModuleComponent implements OnInit {

  constructor(private ngRx: NgRedux<IAppState>) {
  }

  ngOnInit() {
  }

  hasPermissionToMigrate() {
    return hasPermissionTo(this.ngRx, 'migrate eStore');
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-module.component.ts